import { Model } from ".";

export default class VTO extends Model {
	get singularNoun() {
		return "VTO";
	}

	resource() {
		return "vto";
	}
}
